<template>
  <div class="my-2">
    <div v-for="(form, key) in target[prop]" :key="key" class="mb-3">
      <div class="col-sm">
        <div class="card">
          <div class="card-header d-sm-flex justify-content-sm-between">
            <div>
              <h5>{{ titleva }} #{{ key + 1 }}</h5>
            </div>
            <div>
              <button
                type="button"
                class="btn btn-danger btn-clock"
                @click="remove(key)"
              >
                Eliminar <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("Experto técnico") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-9"
                type="search-select"
                v-model="target[prop][key].evaluator_id"
                :list="technicalExpertList"
                :required="true"
              />
            </div>

            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                Datos procedentes
              </label>
              <app-input
                type="textarea"
                class="col-sm-9"
                v-model="target[prop][key].provenance"
                placeholder="Ingrese: SAE o Externo, Nombre de la entidad donde labora, si es privada o pública, Aplica o no convenio"
              />
            </div>

            

            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                Número total de días
              </label>
              <app-input
                type="number"
                class="col-sm-9"
                v-model="target[prop][key].number_days"
                placeholder="Ingrese total de días"
                :required="true"
              />
            </div>

            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                Observaciones
              </label>
              <app-input
                type="textarea"
                class="col-sm-9"
                v-model="target[prop][key].observations"
                placeholder="Ingrese observaciones"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <button type="button" class="btn btn-primary" @click="addEvaluators()">
      Añadir Experto técnico
    </button>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosGet } from "@/app/helpers/AxiosHelper";
export default {
  name: "DynamicFormExp",
  mixins: [FormMixin, ModalMixin],
  props: {
    titleva: String,
    model: Object,
    self: String,
    technicalExpertList: Array,
    evaluationTeam: Object,
  },
  data() {
    return {
      target: this.model,
      prop: this.self,
      inputs: {},
    
      
    };
  },
  created() {
     this.checkDataEvaluation();
  },
  methods: {
    addEvaluators() {
      const { target, prop } = this.$data;
      if (!target[prop]) {
        this.$set(target, prop, []);
      }
      target[prop].push({ });
    },
    checkDataEvaluation() {
      if (this.evaluationTeam.technicalExpert.length > 0) {
        for (var i = 0; i < this.evaluationTeam.technicalExpert.length; i++) {
          this.addEvaluators();
          this.target[this.prop][i].evaluator_id = this.evaluationTeam.technicalExpert[i].evaluator_id;
          this.target[this.prop][i].provenance = this.evaluationTeam.technicalExpert[i].provenance;
          this.target[this.prop][i].number_days = this.evaluationTeam.technicalExpert[i].number_days;
          this.target[this.prop][i].observations = this.evaluationTeam.technicalExpert[i].observations;
        }
      }
    },
    remove(i) {
      const { target, prop } = this.$data;
      if (target[prop]) {
        target[prop].splice(i, 1);
      }
    },
    
  },
};
</script>
